export default {
    required: "Une valeur est requise",
    email: "La valeur n'est pas une adresse e-mail valide",
    mask: "La valeur est invalide.",
    maxValue: "La valeur maximale est {max}",
    maxLength: "La longueur maximale autorisée est {max}",
    regex: "La valeur est invalide.",
    server: {
        DELEGATES_NOT_ENABLED: "Les délégués ne sont pas activés pour ce partenaire.",
        DELEGATE_DOES_NOT_EXIST: "Le délégué n'existe pas",
        DELEGATE_UPDATE_PERMISSIONS_MISMATCH: "Impossible de mettre à jour un délégué qui ne vous appartient pas.",
        DELEGATE_DELETE_PERMISSIONS_MISMATCH: "Impossible de supprimer un délégué qui ne vous appartient pas.",
        DELEGATE_ALREADY_EXISTS: "Une règle de délégation correspondant à ces critères existe déjà.",
        DELEGATE_CANNOT_BE_SELF: "Vous ne pouvez pas vous ajouter vous-même en tant que délégué.",
        IMPERSONATE_USER_NO_PERMISSIONS: "L'utilisateur {email} n'a pas accès à DXC Gear et aucune commande ne peut être passée en son nom.",
        INVALID_CART_ITEM: "Produit {product} non autorisé",
        INVALID_USER_TYPE: "L'utilisateur n'est pas un employé.",
        INVALID_EMPLOYMENT_STATUS: "L'utilisateur n'est pas un employé actif",
        USER_NOT_FOUND: "Utilisateur introuvable",
        "Invalid user type": "Type d'utilisateur invalide",
        "User not found": "Utilisateur introuvable"
    }
}